"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var dayPartCell_1 = require("../dayPartCell");
var DayPartTable = /** @class */ (function (_super) {
    tslib_1.__extends(DayPartTable, _super);
    function DayPartTable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onMouseDown = function (day, hour, selected) {
            var onUpdateCell = _this.props.onUpdateCell;
            onUpdateCell(day, hour, selected);
            _this.setState({ isMouseDown: true, startHour: hour, startDay: day, selected: selected });
        };
        _this.onMouseUp = function (e) {
            _this.setState({ isMouseDown: false });
        };
        _this.onMouseOver = function (day, hour, e) {
            var onBulkChange = _this.props.onBulkChange;
            if (onBulkChange && _this.state.isMouseDown) {
                var minHour = Math.min(_this.state.startHour, hour);
                var maxHour = Math.max(_this.state.startHour, hour);
                var minDay = Math.min(_this.state.startDay, day);
                var maxDay = Math.max(_this.state.startDay, day);
                var items = [];
                for (var currDay = minDay; currDay <= maxDay; currDay++) {
                    for (var currHour = minHour; currHour <= maxHour; currHour++) {
                        if (_this.getSelectedValue(currDay, currHour) !== _this.state.selected) {
                            items.push({ day: currDay, hour: currHour, selected: _this.state.selected });
                        }
                    }
                }
                onBulkChange(items);
            }
        };
        _this.state = { isMouseDown: false, startHour: null, startDay: null, selected: false };
        return _this;
    }
    DayPartTable.prototype.getSelectedValue = function (day, hour) {
        var _a = this.props, dayPartingMatrix = _a.dayPartingMatrix, Hours = _a.Hours;
        return dayPartingMatrix[(day * Hours.length) + hour];
    };
    DayPartTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, dayPartingMatrix = _a.dayPartingMatrix, Days = _a.Days, Hours = _a.Hours, theme = _a.theme;
        return (React.createElement("div", { className: theme.dayPartTable },
            React.createElement("table", { cellSpacing: "0" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        Hours.map(function (hour) { return (React.createElement("th", { className: theme.hourCell, key: hour.value }, hour.label)); }))),
                React.createElement("tbody", { onMouseLeave: this.onMouseUp }, Days.map(function (day) {
                    return (React.createElement("tr", { key: day.value },
                        React.createElement("td", { className: theme.dayCell }, day.label),
                        Hours.map(function (hour) { return (React.createElement(dayPartCell_1.DayPartCell, { key: "" + day.value + hour.value, hour: hour.value, day: day.value, selected: _this.getSelectedValue(day.value, hour.value), onCellMouseDown: _this.onMouseDown, onCellMouseOver: _this.onMouseOver, onCellMouseUp: _this.onMouseUp })); })));
                })))));
    };
    DayPartTable.defaultProps = {
        onUpdateCell: utils_1.noop,
        onBulkChange: utils_1.noop
    };
    DayPartTable.contextTypes = {};
    return DayPartTable;
}(React.Component));
exports.default = DayPartTable;
